import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { CustomFontAwesomeIconProps } from './types/custom-font-awesome-icon.props';

export const ChevronDown = (props: CustomFontAwesomeIconProps) => {
  return (
    <FontAwesomeIcon
      icon={['fasr', 'chevron-down']}
      {...props}
    />
  );
};
